import PropTypes from 'prop-types';
import SvgIcon from '@mui/material/SvgIcon';
import { cx } from 'ramda-extension';

// rendered through svgr, but edited - passing classNames
const GkclLogo = ({ className, ...props }) => (
	<SvgIcon {...props} className={cx('Icon Icon--kcl', className)} viewBox="0 0 40 40">
		<path d="M29.68 30.638H9.69v2.168h19.99v-2.168Zm.107-23.335h-6.668v6.667a6.667 6.667 0 0 0 6.668-6.667Zm0 20a6.666 6.666 0 0 0-6.668-6.665v6.665h6.668ZM16.452 13.97h6.667v6.668h-6.667v6.665H9.786v-20h6.666v6.667Z" />
	</SvgIcon>
);

GkclLogo.propTypes = {
	className: PropTypes.string,
};

export default GkclLogo;
